import React from 'react';
import { WORD_APP_PATH } from '../config';
import RulesPage from './RulesPage';

function RulesContent() {
  return (
    <div className="rules-content">
      <section className="rules-section">
        <h2>Как играть</h2>
        <ul>
          <li>Каждый день публикуется одно слово из 9 букв.</li>
          <li>Только существительные.</li>
          <li>Буквы перемешаны: соберите правильное слово.</li>
          <li>Количество попыток не ограничено; очки даёт только верный ответ.</li>
        </ul>
      </section>

      <section className="rules-section rules-section--note">
        <h2>⏱ Почему время идёт с момента публикации</h2>
        <p>
          Секундомер запускается, когда слово опубликовано: один общий старт для всех,
          а не тогда, когда вы открыли игру.
        </p>
        <p>Так хитрецы, которые уже знают слово, не смогут вас обогнать.</p>
      </section>

      <section className="rules-section">
        <h2>Как считаются очки</h2>
        <ul>
          <li>Очки зависят от того, каким по счёту вы угадали слово среди всех игроков.</li>
          <li>1-е место: 100 очков, 2-е: 95, 3-е: 90, и так далее (−5 за каждое место).</li>
          <li>Минимум: 5 очков.</li>
          <li>Ваше время от публикации показывается в результате.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Рейтинг</h2>
        <ul>
          <li>В таблице лидеров суммируются очки за день / неделю / всё время.</li>
          <li>При равной сумме выше тот, у кого меньше среднее время.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Недельные значки</h2>
        <ul>
          <li>Каждый понедельник в 11:00 (МСК), вместе с новым словом, публикуются итоги прошлой недели в «Знаменитостях Паба».</li>
          <li>Самые Гениальные: 1–3 место в недельном рейтинге.</li>
          <li>Самые Быстрые: 1–3 место по лучшему времени за неделю.</li>
          <li>Завсегдатаи: угаданы все слова недели.</li>
        </ul>
      </section>
    </div>
  );
}

function Rules() {
  return (
    <RulesPage gameTitle="Слово Дня" playTo={`${WORD_APP_PATH}/game`}>
      <RulesContent />
    </RulesPage>
  );
}

export default Rules;
